// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"252a3aa0","65":"83133aed","170":"5c433c80","197":"31601b51","223":"8651eb86","319":"3fb7cd0a","344":"6e705106","453":"3f038b64","499":"289b2054","612":"8a109b4e","849":"baac5ee9","900":"c706851f","908":"0a23d064"}[chunkId] + ".chunk.js";
};